module.exports = __webpack_public_path__ + "img/svg/icon-hand.706beb80d7f0ba8d3f188257fe04722c.svg";